import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import type { AppEnvironment } from './environments/environment.types';

let firebaseApp: FirebaseApp | null = null;

/**
 * Initializes Firebase Web SDK when `environment.firebaseWeb` is set (browser only).
 * Analytics is created only if the browser supports it (avoids SSR / unsupported environments).
 */
export function initFirebaseWeb(environment: AppEnvironment): void {
  if (!environment.firebaseWeb || typeof window === 'undefined') {
    return;
  }
  if (getApps().length > 0) {
    firebaseApp = getApps()[0]!;
    return;
  }
  firebaseApp = initializeApp({ ...environment.firebaseWeb });
  void isSupported().then((supported) => {
    if (supported && firebaseApp) {
      getAnalytics(firebaseApp);
    }
  });
}

export function getFirebaseWebApp(): FirebaseApp | null {
  return firebaseApp ?? (getApps().length > 0 ? getApps()[0]! : null);
}
